module.exports = __webpack_public_path__ + "img/logo2.7059a549.svg";